<template>
  <div
    class="riskTop-wrap"
    @mouseenter="handleInterval('enter')"
    @mouseleave="handleInterval('leave')"
  >
    <Card-border></Card-border>
    <div class="riskTop-top">
      <div class="riskTop-title">风险应用 top10</div>
      <div class="riskTop-radiobtn">
        <RadioBtn
          :config="DEFAULTCONFIG"
          :activeVal="activeVal"
          @onChange="radioChange"
          :autoChange="true"
          :counter="props.counter"
          ref="radioBtnRef"
        />
      </div>
    </div>
    <div class="riskTop-content">
      <div
        class="risk-chartbox"
        :style="{ height: chartData.length * 32 + 'px' }"
      >
        <BarChart
          v-if="chartData.length !== 0"
          :barChartData="chartData"
          :barIndex="1"
          @handleClickBar="handleClickBar"
          :click="handleClick"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from "vue";
import CardBorder from "@/components/common/card-border.vue";
import BarChart from '../chartComponent/bar-chart.vue';
import RadioBtn from "@/components/common/radio-btn.vue";
export default {
  props: {
    data: Object,
    counter: Number,
  },
  components: {
    CardBorder,
    RadioBtn,
    BarChart
  },

  setup(props) {
    const radioBtnRef = ref(null);
    const DEFAULTCONFIG = [
      {
        label: '漏洞风险',
        value: 'scan'
      },
      {
        label: '隐私合规',
        value: 'compliance'
      }
    ];
    const activeVal = ref(DEFAULTCONFIG[0].value);
    const chartData = ref([]);
    const chatDataInfo = ref(props.data);
    const radioChange = (val) => {
      activeVal.value = val;
      init();
    };
    const init = () => {
      chartData.value = [];
      chatDataInfo.value = props.data;
      setTimeout(() => {
        if (props.data) {
          chartData.value = props.data[activeVal.value].map((item) => {
            return {
              ...item,
              name: item.app_name || item.name,
              value: item.total
            };
          });
        }
      }, 100);
    };
    const handleInterval = (type) => {
      radioBtnRef.value.handleInterval(type);
    };
    const handleClick = (item) => {
      const { name } = item;
      let findItem = chartData.value.find((item) => item.name === name);
      if (findItem) {
        const { type } = findItem;
        let url;
        if (type === '1') {
          url = activeVal.value === 'scan' ? '#/safemonitor/scan/list' : '#/safemonitor/privacyScan/list';
        } else {
          url = activeVal.value === 'scan' ? '#/safemonitor/iosScan/list' : '#/safemonitor/privacyIosScan/list';
        }
        window.location.href = `${url}?id=${findItem.id}`;
      }
    };
    // 监听传值，刷新图表
    watch(activeVal, () => {
      init();
    });
    // 监听传值，刷新图表
    watch(props, (val) => {
      // 当data数据变化时才会初始化图表
      if (val.data !== chatDataInfo.value) {
        init();
      }
    });
    init();
    return {
      activeVal,
      DEFAULTCONFIG,
      radioChange,
      props,
      chartData,
      radioBtnRef,
      handleInterval,
      handleClick
    };
  },
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>